import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../Loader/LoaderSlice';
import { setApiError } from '../Error/ErrorSlice';
import { fireApi } from '../../../utils/FireApi';
import { JourneyApi } from '../../../utils/Apis';
import { resetStore } from '../../Actions';

const initialState = {
  list_data: null,
  template_name_list: null,
  edit_data: null,
  template_data: null
};

const JourneySlice = createSlice({
  name: 'Journey',
  initialState,
  reducers: {
    setJourneyGrid(state, action) {
      state.list_data = action.payload;
    },
    setTemplateNameList(state, action) {
      state.template_name_list = action.payload;
    },
    setJourneyEdit(state, action) {
      state.edit_data = action.payload;
    },
    setJourneyTemplate(state, action) {
      state.template_data = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

// Journey List
export const getJourneysList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: JourneyApi?.JourneyList,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setJourneyGrid(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setJourneyGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Journey List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Journey List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const getTemplateDropdown = () => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: JourneyApi?.templateNameList
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(
        setTemplateNameList(
          res?.data?.data?.journeyTemplateNameList
            ? res?.data?.data?.journeyTemplateNameList
            : res?.data
        )
      ); // store in redux
      return res?.data;
    } else {
      dispatch(setTemplateNameList(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Journey template name list failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Journey template name exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const getAllJourneyConfigData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: JourneyApi?.journeyEdit,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setJourneyEdit(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setJourneyEdit(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Journey Edit failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Journey Edit exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Journey Template
export const getJourneyTemplate = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: JourneyApi?.TemplateList,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setJourneyTemplate(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setJourneyTemplate(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Journey Template failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Journey Template exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const { setJourneyGrid, setTemplateNameList, setJourneyEdit, setJourneyTemplate } =
  JourneySlice.actions;
export default JourneySlice.reducer;
